import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import DatePicker from '@/shared/components/input/DatePicker';
import moment from 'moment';
import { falseFunc, isBeforeMinimum } from '@/shared/utils/validationHelpers';
import messages from './taskMessages';

export default class ChangeTaskExecutionDateModal extends Component {
  state = {
    executionDate: moment.utc().startOf('day'),
  };

  componentDidMount() {
    this.form = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props;

    if (prevProps.show !== show) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(() => ({
        executionDate: moment.utc(),
      }));
    }
  }

  static propTypes = {
    onSave: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  validate() {
    const { executionDate } = this.state;
    if (isBeforeMinimum(executionDate)) return false;

    if (!this.form || !this.form.current) return true;
    return this.form.current.reportValidity();
  }

  executionDateChanged = input => {
    this.setState({
      executionDate: input,
    });
  };

  onSave = () => {
    const { executionDate } = this.state;
    const { onSave } = this.props;
    if (!this.validate()) return Promise.reject(new Error('invalid form'));

    const parameters = {
      executionDate,
      field: 0,
    };

    return onSave(parameters);
  };

  render() {
    const { show, intl } = this.props;
    const { executionDate, dateFocused } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeTaskExecutionDate)}
        show={show}
        onClose={this.closeModal}
        disabled={!this.validate()}
        onSave={this.onSave}
      >
        {show && (
          <form ref={this.form}>
            <div className="form-horizontal">
              <div
                className={classNames('form-group', {
                  'has-error': isBeforeMinimum(executionDate),
                })}
              >
                <label className="control-label col-sm-3">
                  <FormattedMessage {...messages.ExecutionDate} />
                </label>
                <div className="col-md-6">
                  <DatePicker
                    placeholder={intl.formatMessage(messages.ExecutionDate)}
                    date={executionDate}
                    onDateChange={this.executionDateChanged}
                    focused={dateFocused}
                    onFocusChange={({ focused }) => this.setState({ dateFocused: focused })}
                    id="taskExecutionDate"
                    block
                    small
                    isOutsideRange={falseFunc}
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      </OkCancelModal>
    );
  }
}
